// ElementList.tsx - Element Listeleme Sayfasi
// Periodic table grid - kategori bazli gruplama
// App Layout (Sidebar + Topbar + Footer)

import { Filter, Search } from 'lucide-react'
import { useEffect, useState } from 'react'
import ElementCard from '../components/element/ElementCard'
import Topbar from '../components/layout/Topbar'
import { Element } from '../types/element'

export default function ElementList() {
  const [elements, setElements] = useState<Element[]>([])
  const [filteredElements, setFilteredElements] = useState<Element[]>([])
  const [searchQuery, setSearchQuery] = useState('')
  const [selectedCategory, setSelectedCategory] = useState<string>('all')
  const [loading, setLoading] = useState(true)

  // Fetch elements
  useEffect(() => {
    void fetchElements()
  }, [])

  const fetchElements = async () => {
    try {
      const response = await fetch('http://localhost:8004/api/v1/elements/')
      const data = (await response.json()) as Element[]
      setElements(data)
      setFilteredElements(data)
    } catch (error) {
      console.error('Element fetch error:', error)
    } finally {
      setLoading(false)
    }
  }

  // Search + Filter
  useEffect(() => {
    let filtered = elements

    // Category filter
    if (selectedCategory !== 'all') {
      filtered = filtered.filter(e => e.category_id === selectedCategory)
    }

    // Search filter
    if (searchQuery.trim()) {
      const query = searchQuery.toLowerCase()
      filtered = filtered.filter(e =>
        e.symbol.toLowerCase().includes(query) ||
        e.name.toLowerCase().includes(query) ||
        e.function_desc?.toLowerCase().includes(query)
      )
    }

    if (filtered) {
      setFilteredElements(filtered)
    }
  }, [searchQuery, selectedCategory, elements])

  // Kategori bazli gruplama
  const groupedElements = filteredElements.reduce((acc, element) => {
    const cat = element.category_id || 'diger'
    if (!acc[cat]) {
      acc[cat] = []
    }
    acc[cat].push(element)
    return acc
  }, {} as Record<string, Element[]>)

  const categories = Array.from(new Set(elements.map(e => e.category_id || 'diger')))

  return (
    <div className="flex h-screen" style={{ background: 'var(--body-bg)' }}>      <div className="flex-1 flex flex-col overflow-hidden">
        <Topbar />

        <main className="flex-1 overflow-auto p-6">
          {/* Header */}
          <div className="mb-6">
            <h1 className="text-3xl font-bold mb-2" style={{ color: 'var(--text-primary)' }}>
              Elementler
            </h1>
            <p style={{ color: 'var(--text-secondary)' }}>
              {filteredElements.length} element bulundu - Proje hizlandirma katalizorleri
            </p>
          </div>

          {/* Search + Filter */}
          <div className="card mb-6" style={{ background: 'var(--card-bg)' }}>
            <div className="card-body p-4">
              <div className="flex gap-4">
                {/* Search */}
                <div className="flex-1 relative">
                  <Search
                    size={20}
                    className="absolute left-3 top-1/2 -translate-y-1/2"
                    style={{ color: 'var(--text-secondary)' }}
                  />
                  <input
                    type="text"
                    placeholder="Element ara..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    className="w-full pl-10 pr-4 py-2 rounded"
                    style={{
                      background: 'var(--input-bg)',
                      border: '1px solid var(--border-color)',
                      color: 'var(--text-primary)'
                    }}
                  />
                </div>

                {/* Category Filter */}
                <div className="flex items-center gap-2">
                  <Filter size={20} style={{ color: 'var(--text-secondary)' }} />
                  <select
                    value={selectedCategory}
                    onChange={(e) => setSelectedCategory(e.target.value)}
                    className="px-4 py-2 rounded"
                    style={{
                      background: 'var(--input-bg)',
                      border: '1px solid var(--border-color)',
                      color: 'var(--text-primary)'
                    }}
                  >
                    <option value="all">Tum Kategoriler</option>
                    {categories.map(cat => (
                      <option key={cat} value={cat}>{cat}</option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
          </div>

          {/* Element Grid (Periodic Table Style - Kategori bazli) */}
          {loading ? (
            <div className="text-center py-12" style={{ color: 'var(--text-secondary)' }}>
              Yukleniyor...
            </div>
          ) : (
            <div className="space-y-8">
              {Object.entries(groupedElements).map(([category, categoryElements]) => (
                <div key={category}>
                  <h2
                    className="text-xl font-semibold mb-4"
                    style={{ color: 'var(--text-primary)' }}
                  >
                    {category} ({categoryElements.length})
                  </h2>
                  <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">
                    {categoryElements.map(element => (
                      <ElementCard
                        key={element.symbol}
                        element={element}
                        onClick={() => {
                          // Element detay modal acilabilir (simdilik console)
                          console.log('Element clicked:', element)
                        }}
                      />
                    ))}
                  </div>
                </div>
              ))}
            </div>
          )}
        </main>
      </div>
    </div>
  )
}
